import {Fragment, useEffect, useState} from "react";
import {useHelperService} from "../../services/helper-service";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {useAuthService} from "../../services/auth-service";
import {useAttachmentService} from "../../services/attachment-service";
import GalleryWrapper from "../attachments/gallery-wrapper";
import React from 'react';

const Attachment = ({attachment, controls=true, meta=true, gallery=true, onDelSuccess=null, editAction=null, ...props}) => {
  const [filetype, setFiletype] = useState(null);
  const helperService = useHelperService();
  const attachmentService = useAttachmentService();
  const auth = useAuthService();

  useEffect(()=>{
    if (!attachment){
      setFiletype(null);
    }

    if (attachment.file_type.includes('image/')){
      setFiletype('image');
    }
    else if (attachment.file_type.includes('pdf/')){
      setFiletype('pdf');
    }
    else {
      setFiletype('document');
    }

  }, [attachment])

  function editAttachment(){
    if (editAction && 'function'===typeof editAction){
      editAction(attachment);
    }
  }

  function delAttachment(){
    if (true===confirm('Naozaj odstrániť záznam?')){
      attachmentService.delModel(attachment.id)
        .then(()=>{
          if (onDelSuccess && 'function'===typeof onDelSuccess){
            onDelSuccess(attachment);
          }
        })
        .catch(error => {
          addErrorMessage( error.response && error.response.data && error.response.data.message ? error.response.data.message : "Nepodarilo sa získať detail.");
        });
    }
  }

  return (
      <div className="attachment border border-light rounded shadow-sm d-flex position-relative p-2 bg-white mb-1" style={{minHeight:"110px"}}>
          {controls && <>
              {auth.can(['manage_users']) && editAction && <span onClick={()=>editAttachment()}
                                                                 className="action-icon clickable hover-text-primary position-absolute" style={{right:'30px',top:'8px'}}>
            <i className="uil uil-pen"></i></span>}
              {auth.can(['manage_users']) && <span onClick={()=>delAttachment()}
                                                   className="action-icon clickable hover-text-danger position-absolute" style={{right:'8px',top:'8px'}}>
            <i className="uil uil-minus-circle"></i></span>}
          </>}
          <div className="d-flex flex-column justify-content-center align-items-start p-1">
              {filetype==='image' && <>
                {gallery && <GalleryWrapper>
                    <a key={'gwi_'+attachment.id} href={attachment.url} className="d-inline-block" style={{maxWidth:'100px', maxHeight:'100%'}}>
                        <img src={attachment.thumbUrl} alt={attachment.title} style={{maxWidth:'100px', maxHeight:'100%', objectFit:'cover'}} />
                    </a>
                </GalleryWrapper>}
                {!gallery && <img src={attachment.thumbUrl} alt={attachment.title} style={{maxWidth:'100px', maxHeight:'100%', objectFit:'cover'}} />}
              </>}

              {filetype==='pdf' && <a title="Otvoriť na novej karte" href={attachment.url} target="_blank">
                  <div style={{width:'40px', textAlign: 'center'}}>
                      <span className="mdi mdi-file"></span>
                  </div>
              </a>}

              {filetype==='document' && <a title="Stiahnť dokument" href={attachment.url} download>
                  <div style={{width:'40px', textAlign: 'center'}}>
                      <span className="mdi mdi-file"></span>
                  </div>
              </a>}
          </div>
          {meta &&
              <div className="d-flex flex-column justify-content-center align-items-start p-1 text-break">
                  <h5 className="mb-0">{attachment.title}</h5>
                  <div>
                    <div>
                      {attachment.attachment_type && <span className="badge bg-primary me-1 my-1">{attachment.attachment_type.title}</span>}
                      {attachment.category && <span className="badge bg-indigo me-1 my-1">{attachment.category.title}</span>}
                    </div>
                      <span title="Vytvorené" className="me-1">
                  <span className="mdi mdi-clock-outline me-1"></span>
                          {helperService.formatDateTime(attachment.created_at)}
                </span>
                      {attachment.description && <OverlayTrigger overlay={<Tooltip>{attachment.description}</Tooltip>}>
                          <span className="me-1"><i className="mdi mdi-comment"></i></span>
                      </OverlayTrigger>}
                  </div>
              </div>}
      </div>
  );
}

export default React.memo(Attachment);
